//datepicker
$.extend( $.fn.datepicker.defaults, {
  language: "en",
  format: 'yyyy-mm-dd',
  autoclose: true,
  todayHighlight: true
});
